var modules_640a77b2 = {"container":"DateInput_module_container__23d7f6fa","calendar-wrapper":"DateInput_module_calendarWrapper__23d7f6fa"};
import "../../../assets/esm/components/DateInput/src/DateInput~DI-TrJoH.css";

export { modules_640a77b2 as default };
//# sourceMappingURL=DateInput.module.less.js.map
